import { getDataMapper, mapField } from "@/shared";

export const mapRepairFiltersToServer = getDataMapper({
    admin_user_id: mapField("employee", (employee) => employee?.userId ?? null),
    human_id: mapField("clientHumanId", (id) => {
        return id != null ? Number(id) : null;
    }),
    repair_state_id: mapField("repairStatuses", (s) => {
        return s?.id != null ? Number(s.id) : null;
    }),
});
